var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    ref: "select",
    attrs: {
      dense: "",
      "hide-details": "",
      "menu-props": { offsetY: true },
      items: _vm.selectOptions,
      "no-data-text": "no options available",
      multiple: _vm.isMultiple,
    },
    on: {
      focus: function ($event) {
        _vm.focused = true
      },
      blur: function ($event) {
        _vm.focused = false
      },
      change: function ($event) {
        return _vm.apply()
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "selection",
          fn: function ({ item, index }) {
            return [
              index === 0
                ? _c("v-chip", { attrs: { "x-small": "" } }, [
                    _c("span", [_vm._v(_vm._s(item.text))]),
                  ])
                : _vm._e(),
              index === 1
                ? _c("span", { staticClass: "grey--text caption" }, [
                    _vm._v(" (+" + _vm._s(_vm.value.length - 1) + " others) "),
                  ])
                : _vm._e(),
            ]
          },
        },
        !_vm.focused
          ? {
              key: "append-outer",
              fn: function () {
                return [
                  _vm.showClearIcon
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "pointer",
                          attrs: {
                            color: !_vm.clearIconHovered ? "green" : "red",
                          },
                          on: {
                            mouseenter: function ($event) {
                              _vm.clearIconHovered = true
                            },
                            mouseleave: function ($event) {
                              _vm.clearIconHovered = false
                            },
                            click: function ($event) {
                              return _vm.clear()
                            },
                          },
                        },
                        [_vm._v("mdi-filter-remove")]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
    model: {
      value: _vm.selectValue,
      callback: function ($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }